import * as React from 'react';

import {useGridReducers} from 'src/js/hooks/useGridReducers';

interface OwnProps {
  gridId: string;
  hasApiState?: boolean;
}
type Props = OwnProps;

export const GridReducerInjector: React.FC<Props> = (props) => {
  const {gridId, hasApiState = false, children} = props;

  const {reducersInitialized} = useGridReducers(gridId, hasApiState);

  return reducersInitialized ? <>{children}</> : null;
};
